import { logout } from '../firebase/auth';
import { currentUser } from '../firebase/auth';
import { Button } from '../ui/components';

export default function AdminTopbar({ title }) {
  const user = currentUser();

  const handleLogout = async () => {
    if (window.confirm('Sign out of the admin panel?')) {
      await logout();
    }
  };

  return (
    <header className="adm-topbar">
      <h2 className="adm-topbar__title">{title}</h2>

      <div className="adm-topbar__right">
        {user && (
          <span className="adm-topbar__user">{user.email}</span>
        )}
        <Button variant="ghost" size="sm" onClick={handleLogout}>
          Sign Out
        </Button>
      </div>
    </header>
  );
}
